import { FormattedMessage } from 'react-intl';

export const getColumns = (farmerId: number) => {
  return [
    // {
    //   title: "id",
    //   dataIndex: "id",
    //   sorter: true,
    // },
    {
      title: <FormattedMessage id="farmer.farmer-plot.farmId" />,
      dataIndex: 'farmId',
      sorter: true,
    },
    {
      title: <FormattedMessage id="farmer.farmer-plot.plotId" />,
      dataIndex: 'plotId',
      sorter: true,
    },
    {
      title: <FormattedMessage id="farmer.farmer-plot.plotAreaHa" />,
      dataIndex: 'plotAreaHa',
      sorter: true,
    },
    {
      title: <FormattedMessage id="farmer.farmer-plot.latitude" />,
      dataIndex: 'latitude',
      sorter: true,
    },
    {
      title: <FormattedMessage id="farmer.farmer-plot.longitude" />,
      dataIndex: 'longitude',
      sorter: true,
    },
  ];
};
